<template>
  <div class="container">
    <div class="row">
      <router-view/>
    </div>
  </div>
</template>

<script>
  export default {
    name    : 'Settings',
  }
</script>

<style scoped>

</style>